export default function StocksGestionRapportActiviteConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('stocks.gestion.rapport.activite');
}

StocksGestionRapportActiviteConfiguration.$inject = ['$translatePartialLoaderProvider'];
